import {
    CONFIRMED_GET_CUSTOMERS
} from '../actions/customer/CustomerTypes';
const initialState = {
    customers: [],
    loading: false,
};

function CustomerReducer(state = initialState, actions) {
    if (actions.type === 'SET_CUSTOMER_LOADING') {
        return {
            ...state,
            loading: actions.payload,
        };
    }
    if (actions.type === CONFIRMED_GET_CUSTOMERS) {
        return {
            ...state,
            customers: actions.payload,
            loading: false,
        };
    }
    return state;
}

export {CustomerReducer};